import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * Load-failure block, same frame as EmptyState: the message plus a bordered
 * "Try again" retry when the caller can refetch.
 */
export function ErrorState({
  message,
  onRetry,
  className,
}: {
  message: string
  onRetry?: () => void
  className?: string
}) {
  return (
    <div className={cn('border-t border-rule/60 py-14 text-center', className)}>
      <p className="text-sm text-inkMid">{message}</p>
      {onRetry ? (
        <Button variant="neutral" size="sm" className="mt-4" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  )
}
